module.exports = __webpack_public_path__ + "media/local_jp.6fb67209.mp3";